import { Text, type StyleProp, type TextStyle } from "react-native";

import { EMBER } from "../theme/tokens";

type Props = {
  children: string;
  style?: StyleProp<TextStyle>;
};

/** Shared sentence-case label for subsections within a card or section. */
export function SubsectionLabel({ children, style }: Props) {
  return (
    <Text
      className="font-dm-sans"
      style={[
        {
          fontSize: 13,
          fontWeight: "600",
          color: EMBER.colors.textMid,
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}

export default SubsectionLabel;
